import React from "react";
import { IconProps } from "./IconProps";

const ArrowSquareOutIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "20Thin":
      return (
        <svg
          aria-label={ariaLabel}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.2286 2.77145C17.3333 2.87619 17.3819 3.01584 17.3742 3.15295L17.375 8.12492C17.375 8.40106 17.1512 8.62496 16.8751 8.625C16.5989 8.62504 16.375 8.40122 16.375 8.12508L16.3744 4.3327L10.9786 9.72855C10.7833 9.92382 10.4667 9.92382 10.2714 9.72855C10.0762 9.53329 10.0762 9.21671 10.2714 9.02145L15.6673 3.62559L11.8749 3.625C11.5988 3.62496 11.375 3.40106 11.375 3.12492C11.375 2.84878 11.5989 2.62496 11.8751 2.625L16.8471 2.62578C16.9842 2.61815 17.1238 2.6667 17.2286 2.77145ZM3.66161 6.16161C3.68505 6.13817 3.71685 6.125 3.75 6.125H9.375C9.65114 6.125 9.875 5.90114 9.875 5.625C9.875 5.34886 9.65114 5.125 9.375 5.125H3.75C3.45163 5.125 3.16548 5.24353 2.9545 5.4545C2.74353 5.66548 2.625 5.95163 2.625 6.25V16.25C2.625 16.5484 2.74353 16.8345 2.9545 17.0455C3.16548 17.2565 3.45163 17.375 3.75 17.375H13.75C14.0484 17.375 14.3345 17.2565 14.5455 17.0455C14.7565 16.8345 14.875 16.5484 14.875 16.25V10.625C14.875 10.3489 14.6511 10.125 14.375 10.125C14.0989 10.125 13.875 10.3489 13.875 10.625V16.25C13.875 16.2832 13.8618 16.3149 13.8384 16.3384C13.8149 16.3618 13.7832 16.375 13.75 16.375H3.75C3.71685 16.375 3.68505 16.3618 3.66161 16.3384C3.63817 16.3149 3.625 16.2832 3.625 16.25V6.25C3.625 6.21685 3.63817 6.18505 3.66161 6.16161Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default ArrowSquareOutIcon;
